module.exports = __webpack_public_path__ + "position.b8aee4.png";